import React from 'react';
import './Settings.css'
import Slider from '../Common/Slider';

import AKey from '../../Assets/Icons/AKey.svg'
import WKey from '../../Assets/Icons/WKey.svg'
import SKey from '../../Assets/Icons/SKey.svg'
import DKey from '../../Assets/Icons/DKey.svg'
import Mouse from '../../Assets/Icons/Mouse.svg'
import Btn from '../Common/Btn';

const Settings = ({ musicVolume, setMusicVolume, sfxVolume, setSfxVolume, onClose }) => {
    return ( 
        <div className='Settings'>
            <div className='PauseTitle'>
                <p>Options</p>
            </div>

            <div className='SettingsContent'>
                <div className='SettingsInput'>
                    <label>Music Volume</label>
                    <Slider initialValue={musicVolume} onChange={setMusicVolume} />
                </div>

                <div className='SettingsInput'>
                    <label>SFX Volume</label>
                    <Slider initialValue={sfxVolume} onChange={setSfxVolume} />
                </div>
            </div>

            <div className='Controls'>
                <div className='Movement'>
                    <div className='Key'>
                        <img src={WKey} alt="" />
                        <label>Up</label>
                    </div>
                    <div className='TheRest'>
                        <div className='Key'>
                            <img src={AKey} alt="" />
                            <label>Left</label>
                        </div>
                        <div className='Key'>
                            <img src={SKey} alt="" />
                            <label>Down</label>
                        </div>
                        <div className='Key'>
                            <img src={DKey} alt="" />
                            <label>Right</label>
                        </div>
                    </div>
                </div>

                <div className='Key'>
                    <img src={Mouse} alt="" />
                    <label>Interact</label>
                </div>
            </div>

            <div className='SettingsFooter'>
                <Btn 
                    BtnText='Back' 
                    BtnStyle='BlueBtn' 
                    onClick={onClose}
                    sfxVolume={sfxVolume} 
                />
            </div>
        </div>
    );
}
 
export default Settings;